module.exports = __webpack_public_path__ + "static/media/pin.6ce88fcf.svg";